import { render, staticRenderFns } from "./LeaveRequestDetail.vue?vue&type=template&id=3219ba80&scoped=true&"
import script from "./LeaveRequestDetail.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRequestDetail.vue?vue&type=style&index=0&id=3219ba80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3219ba80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAvatar,VCardActions,VCardTitle,VChip,VCol,VIcon,VProgressLinear,VRow})
